import React, { useState } from 'react';
import PmsVendorMaster from './PmsVendorMaster';
import PmsExpenseCategory from './PmsExpenseCategory';
import PmsExpenseApprovalRule from './PmsExpenseApprovalRule';
import PmsExpenseBudget from './PmsExpenseBudget';
import PmsExpenseRecurring from './PmsExpenseRecurring';
import PmsExpenseRoleTemplate from './PmsExpenseRoleTemplate';
import PmsExpenseSettings from './PmsExpenseSettings';
import PmsRevenueTargetAdmin from './PmsRevenueTargetAdmin';

function PmsExpenseMastersHub({ token, selectedProperty, permissions }) {
  const [tab, setTab] = useState('vendor');
  const tabBtn = (active) => ({
    padding: '0.55rem 0.85rem',
    borderRadius: '7px',
    border: '1px solid #cbd5e0',
    background: active ? 'var(--theme-primary)' : '#fff',
    color: active ? '#fff' : '#1f2937',
    cursor: 'pointer'
  });

  return (
    <div style={{ padding: '1rem' }}>
      <h2 style={{ marginTop: 0, color: 'var(--theme-primary)' }}>Expense & Profitability - Masters</h2>
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.7rem', flexWrap: 'wrap' }}>
        <button onClick={() => setTab('vendor')} style={tabBtn(tab === 'vendor')}>Vendor Master</button>
        <button onClick={() => setTab('category')} style={tabBtn(tab === 'category')}>Category Master</button>
        <button onClick={() => setTab('approval-rule')} style={tabBtn(tab === 'approval-rule')}>Approval Rules</button>
        <button onClick={() => setTab('budget')} style={tabBtn(tab === 'budget')}>Budgets</button>
        <button onClick={() => setTab('revenue-targets')} style={tabBtn(tab === 'revenue-targets')}>Revenue Targets</button>
        <button onClick={() => setTab('recurring')} style={tabBtn(tab === 'recurring')}>Recurring Expenses</button>
        <button onClick={() => setTab('role-template')} style={tabBtn(tab === 'role-template')}>Role Templates</button>
        <button onClick={() => setTab('settings')} style={tabBtn(tab === 'settings')}>Settings</button>
      </div>
      <div className="card">
        {tab === 'vendor' ? <PmsVendorMaster token={token} selectedProperty={selectedProperty} /> : null}
        {tab === 'category' ? <PmsExpenseCategory token={token} selectedProperty={selectedProperty} /> : null}
        {tab === 'approval-rule' ? <PmsExpenseApprovalRule token={token} selectedProperty={selectedProperty} /> : null}
        {tab === 'budget' ? <PmsExpenseBudget token={token} selectedProperty={selectedProperty} /> : null}
        {tab === 'revenue-targets' ? <PmsRevenueTargetAdmin token={token} selectedProperty={selectedProperty} permissions={permissions} /> : null}
        {tab === 'recurring' ? <PmsExpenseRecurring token={token} selectedProperty={selectedProperty} /> : null}
        {tab === 'role-template' ? <PmsExpenseRoleTemplate token={token} selectedProperty={selectedProperty} /> : null}
        {tab === 'settings' ? <PmsExpenseSettings token={token} selectedProperty={selectedProperty} /> : null}
      </div>
    </div>
  );
}

export default PmsExpenseMastersHub;
